import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=fc25fd62&scoped=true"
import script from "./VideoItem.vue?vue&type=script&lang=js"
export * from "./VideoItem.vue?vue&type=script&lang=js"
import style0 from "./VideoItem.vue?vue&type=style&index=0&id=fc25fd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc25fd62",
  null
  
)

export default component.exports